<app-page-wrapper>
    <span class="link breadcrumb-link" (click)="goBack()">
        <i class="far fa-angle-left"></i> Back
    </span>
    <div class="mt-2"></div>
    <app-onboarding-banner></app-onboarding-banner>
    <div class="aspect-ratio mt-3">
        <iframe width="100%" height="auto" src="https://www.youtube.com/embed/vuxNaGFnCos" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
    <div class="header">Let's get started!</div>
    
    We are excited to partner with you to help serve your students! 
    Please follow the steps below and you'll have your students learning with Joy School English in no time!

    <div class="border mt-2 mb-2 py-2 implementation-scope" *ngIf="status && status.ImplementationScope">
        Your Implementation Scope: {{ status.ImplementationScope }}
    </div>

    <div class="row mt-3">
        <div class="col-4 step">
            <div class="padding">
                <div class="circle-container">
                    <div class="unit-circle">1</div>
                </div>
                <div class="header">Rostering</div>
                <div class="left">
                    <span>Complete one of the three options below to roster your students.</span>
                </div>
                <a href="/organizations/{{organizationDetails && organizationDetails.ID}}/clever"><button class="btn btn-primary">Complete rostering using Clever</button></a>
                <a href="/organizations/{{organizationDetails && organizationDetails.ID}}/import"><button class="btn btn-primary">Upload a file for us to import</button></a>
                <a href="mailto:support@alegralearning.com">
                    <button class="btn btn-primary">
                        <span>Set up nightly sync with our system</span>
                        <br>
                        <span class="small-text">(for ClassLink or other SIS integrations)</span>
                    </button>
                </a>
                <div class="assign-container">
                    <app-assign-onboarding-modal [organization]="organizationDetails" [onboardingStep]="'rostering'" 
                        [currentAssignee]="(status && status.RosteringAccount)"></app-assign-onboarding-modal>
                </div>
            </div>
        </div>
        <div class="col-4 step">
            <div class="padding">
                <div class="circle-container">
                    <div class="unit-circle">2</div>
                </div>
                <div class="header">Preparing your devices</div>
                <div class="left">
                    For <b>Chromebooks</b> you will access the program by navigating to
                    <a [href]="environment.PLAY_URL">http://play.joyschoolenglish.com</a> in a Chrome browser.
                    Please bookmark this page and save it to your desktop for easy access.
                    <br><br>
                    For <b>iPads/Android devices</b>, visit the relevant app store, search for "Joy School English," and download.
                    Please set our app to auto-update if that is an option in your management tools.
                </div>
                <div class="assign-container">
                    <app-assign-onboarding-modal [organization]="organizationDetails" [onboardingStep]="'device readiness'"
                        [currentAssignee]="(status && status.DevicesAccount)"></app-assign-onboarding-modal>
                </div>
            </div>
        </div>
        <div class="col-4 step">
            <div class="padding">
                <div class="circle-container">
                    <div class="unit-circle">3</div>
                </div>
                <div class="header">Training</div>
                <div class="left">
                    We want to help your teachers get the most out of Joy School English.
                    Schedule your teacher training by booking a time as soon as possible.
                    The training will take approximately 60 minutes.
                </div>
                <a href="https://alegralearning.pipedrive.com/scheduler/G93A3XUl/joy-school-english-training">
                    <button class="btn btn-primary">
                        <img class="button-icon" src="assets/icon-schedule.svg">
                        Schedule training
                    </button>
                </a>
                <div class="assign-container">
                    <app-assign-onboarding-modal [organization]="organizationDetails" [onboardingStep]="'training'" 
                        [currentAssignee]="(status && status.TrainingAccount)"></app-assign-onboarding-modal>
                </div>
            </div>
        </div>
    </div>

    <div class="header">Consistency is the key to success</div>
    
    Our analysis suggests that when students finish the first unit of Joy School English 
    within three weeks of getting started (equivalent to about 120 minutes on the program), 
    they will be on the fast track to success. We want to work with you to make that happen for all of your students.
    <br><br>
    We are here for you and happy to help at any time to ensure a successful implementation! 
    We have a <a href="https://joyschoolenglish.com/start">customer support page</a>
    that includes several short support videos, and a 
    <a href="assets/getting-started-joy-school-english.pdf" download="getting-started-joy-school-english.pdf">
        Getting Started Guide
    </a> 
    for your reference. 
    Our Customer Joy Manager is also available by <a href="email-support" (click)="openSupportModal()">email</a> during business hours. 
    Please let us know if you have any questions about getting started.

    <div class="actions-container row border py-4 mt-4">

        <div class="col-4">
            <a (click)="openSupportModal()">
                <button class="btn btn-primary bottom-button">
                    <img class="button-icon" src="assets/icon-email.svg">
                    Email customer support
                </button>
            </a>
        </div>
        <div class="col-4">
            <a href="https://joyschoolenglish.com/start">
                <button class="btn btn-primary bottom-button">
                    <img class="button-icon" src="assets/icon-customer-support.svg">
                    Customer support page
                </button>
            </a>
        </div>
        <div class="col-4">
            <a href="assets/getting-started-joy-school-english.pdf" download="getting-started-joy-school-english.pdf">
                <button class="btn btn-primary bottom-button">
                    <img class="button-icon" src="assets/icon-getting-started-guide.svg">
                    Getting Started Guide
                </button>
            </a>
        </div>
    </div>
    <app-email-support-modal #emailModal [openModalButtonVisible]="false"></app-email-support-modal>
</app-page-wrapper>